import React, { useEffect, useState } from 'react';
import { Messenger } from '../SMS/Messenger';
import { Drawer } from 'antd';
import { EmailDashboard } from '../Email/EmailDashboard';

export function EmailCampaignMembers(props) {

    const from = () => {
        if(props.campaignType === 'client') {
            return 'client-campaigns';
        } else {
            return 'campaigns';
        }
    }

    const [modalInfo, setModalInfo] = useState({
        show: false
    });

    useEffect(() => {
        if (props.showModal) {
            setModalInfo({
                show: true
            });
        }
    }, [props.showModal]);

    function handleClose() {
        setModalInfo({
            show: false
        });

        setTimeout(() => {
            props.hideModal();
        }, 1000);
    }

    return (
        <Drawer
            closeIcon={<i className="fas fa-chevron-left float-left"></i>}
            title='Email Campaign Members'
            placement={'right'}
            onClose={handleClose}
            open={modalInfo.show}
            key='drawer'
            width={'100%'}
            className="d-flex"
            footer={
                <div className="d-flex justify-content-between" key="1">
                    <div>
                        <button className="btn btn-outline-primary float-right">Close</button>
                    </div>
                </div>
            }
        >
            <EmailDashboard from={from()} selectedCandidates={props.selectedCandidates} selectedClients={props.selectedClients} selectedUsers={props.selectedUsers} handleClose={handleClose} />
        </Drawer>
    )
}